import translationar from './translation-ar.json';
import translationbn from './translation-bn.json';
import translationde from './translation-de.json';
import translationen from './translation-en.json';
import translationes from './translation-es.json';
import translationfr from './translation-fr.json';
import translationgu from './translation-gu.json';
import translationhi from './translation-hi.json';
import translationit from './translation-it.json';
import translationja from './translation-ja.json';
import translationkn from './translation-kn.json';
import translationko from './translation-ko.json';
import translationml from './translation-ml.json';
import translationmr from './translation-mr.json';
import translationnl from './translation-nl.json';
import translationpl from './translation-pl.json';
import translationpt from './translation-pt.json';
import translationsv from './translation-sv.json';
import translationta from './translation-ta.json';
import translationte from './translation-te.json';
import translationth from './translation-th.json';
import translationtr from './translation-tr.json';
import translationvi from './translation-vi.json';
import translationzh from './translation-zh.json';
import translation from './translation.json';

// webpack transforms these JSON imports to resource URLs, so we cast our export accordingly here.
const i18nEndPointMap = {
  'translation-ar.json': translationar,
  'translation-bn.json': translationbn,
  'translation-de.json': translationde,
  'translation-en.json': translationen,
  'translation-es.json': translationes,
  'translation-fr.json': translationfr,
  'translation-gu.json': translationgu,
  'translation-hi.json': translationhi,
  'translation-it.json': translationit,
  'translation-ja.json': translationja,
  'translation-kn.json': translationkn,
  'translation-ko.json': translationko,
  'translation-ml.json': translationml,
  'translation-mr.json': translationmr,
  'translation-nl.json': translationnl,
  'translation-pl.json': translationpl,
  'translation-pt.json': translationpt,
  'translation-sv.json': translationsv,
  'translation-ta.json': translationta,
  'translation-te.json': translationte,
  'translation-th.json': translationth,
  'translation-tr.json': translationtr,
  'translation-vi.json': translationvi,
  'translation-zh.json': translationzh,
  'translation.json': translation
}

export default i18nEndPointMap;